
import React from 'react'
import {connect} from "react-redux";
import Formulario from '../../framework2/ej2/UI/Formulario'
import {
    CAMPOTIPO_CADENA,
    CAMPOTIPO_CHECK,
    CAMPOTIPO_FECHAACTIVABLE, CAMPOTIPO_FIRMAMAIL,
    CAMPOTIPO_LISTACHECKS, CAMPOTIPO_MEMO
} from '../../framework2/ej2/UI/TiposCampos'
import { getElementoConfigNombre, getGridConfigNombre} from "../../framework2/ej2/utils/CrudUtilsJPA";
import {CELLTIPO_CADENA, CELLTIPO_FECHAHORA} from "../../framework2/ej2/UI/TiposCeldas";
import {sha256} from "js-sha256";
import UsuarioRoles from "./UsuarioRoles";



class FormularioUsuario extends React.Component {


    constructor(props) {
        super(props)
        this.state = {
            usuario: null,
        }

        this.gridConfig= getGridConfigNombre("Usuario");
        this.gridConfig.columnas.push(
            //{campo:"rolCodigo.nombre", titulo: "Rol", tipo: CELLTIPO_CADENA, ancho:150},
            {campo:"roles", titulo: "Roles", tipo: CELLTIPO_CADENA, ancho:150},
            {campo:"login", titulo: "Usuario", tipo: CELLTIPO_CADENA, ancho:150},
            {campo:"usuarioAd", titulo: "Usuario AD", tipo: CELLTIPO_CADENA, ancho:150},
            {campo:"ultimoacceso", titulo: "Último acceso", tipo: CELLTIPO_FECHAHORA, ancho:150}
            );
        this.gridConfig.editable= false;
        this.gridConfig.estilo={height: '600px'};

        this.elementoConfig= getElementoConfigNombre("Usuario");
        this.elementoConfig.campos.push(
            //{campo:"rolCodigo", titulo: "Rol", tipo: "com.ej2sistemas.ej2bizsuite40.Rol", cols:6, obligatorio: true},
            {campo:"login", titulo: "Usuario", tipo: CAMPOTIPO_CADENA, cols: 2, icon:"user", noMayus: true, obligatorio: true},
            {campo:"magicword", titulo: "Contraseña", tipo: CAMPOTIPO_CADENA, cols: 2, icon:"key", noMayus: true},
            {campo:"usuarioAd", titulo: "Usuario AD", tipo: CAMPOTIPO_CADENA, cols: 2, icon:"user", noMayus: true, obligatorio: true},
            {campo:"empresasexclusivas", titulo: "Empresas exclusivas", tipo: CAMPOTIPO_MEMO, cols: 6, icon:"user", noMayus: true},
            {campo:"firma", titulo: "Firma", tipo: CAMPOTIPO_FIRMAMAIL, cols: 12},

        );

        this.formulario= React.createRef();
    }


    static getDerivedStateFromProps(nextProps, prevState){
        const newState = {};
        /*
        if(nextProps.usuario !== prevState.usuario){
            newState.usuario= nextProps.usuario;
        }
        */
        if (Object.keys(newState).length > 0)
            return newState;
        else
            return null;
    }

    onAntesGuardar= (elemento, elementoInicial) => {
        console.log("ONANTESGUARDAR");
        let newElemento= {...elemento};
        if (elemento.magicword !== "")
            newElemento.magicword = sha256(newElemento.magicword);
        else
            newElemento.magicword = "";
        if (!elemento.rolCodigo)
            newElemento.rolCodigo= {codigo: 9999};
        console.log("newElemento: ", newElemento);
        return newElemento;
    }


    onAntesMostrarDatos= (elemento) => {
        let newElemento= {...elemento};
        newElemento.magicword= "";
        return newElemento;
    }

    seleccionado= (elemento) => {
        console.log("SELECCIONADO");
        console.log("elemento: ", elemento);
        this.setState({usuario : elemento});
    }

    rolesGuardados= () => {
        console.log("FormularioUsuario - rolesGuardados");
        console.log("this.formulario: ", this.formulario);
        if (this.formulario && this.formulario.current)
            this.formulario.current.cambiarTabDatos("datos");
    }


    render() {
        const {usuario} = this.state;
        console.log("FORMULARIOUSUARIO - RENDER");
        console.log("usuario:");
        console.log(usuario);
        return (
                <Formulario icon="user" titulo="Usuarios"
                            ref={this.formulario}
                            gridConfig={this.gridConfig}
                            elementoConfig={this.elementoConfig}
                            onElementoSeleccionado={this.seleccionado}
                            onElementoBeforeSave={this.onAntesGuardar}
                            onElementoBeforeShow={this.onAntesMostrarDatos}
                            usuario={this.props.auth.usuario}
                >
                    <UsuarioRoles titulo="Roles" enTab={true} usuario={usuario}
                                    onGuardado={this.rolesGuardados}/>
                </Formulario>
        )
    }


}

//<UsuarioNotificaciones  titulo="Notificaciones" enTab={true} usuario={usuario} />

FormularioUsuario.propTypes = {}

const mapStateToProps = function(state) {
    return {
        auth: state.auth,
        estado: state.estado,
    }
}
export default connect(mapStateToProps)(FormularioUsuario);



